import { _post, _get, _delete } from "./Axios";

export default class HakAksesApi {
  static get(id = null) {
    if (id == null) {
      return _get("users/groups/");
    } else {
      return _get("users/groups/" + id);
    }
  }
  static getByKeyword(keyword = "") {
    return _get("users/groups/?keyword=" + keyword);
  }
  static getbyparam(parameters) {
    let params = [];
    Object.keys(parameters).forEach((element) => {
      params.push(element + "=" + parameters[element]);
    });
    params = params.join("&");
    return _get("users/groups/?" + params);
  }
  static searchOwner(key = null) {
    return _get("users/groups/searchowner?key=" + key);
  }
  static post(data) {
    return _post("users/groups/", data);
  }
  static update(id, data) {
    return _post("users/groups/" + id, data);
  }
  static changePassword(id, data) {
    return _post("users/groups/" + id + "/changepassword", data);
  }
  static delete(id) {
    return _delete("users/groups/" + id);
  }
  static check_token(data) {
    return _post("auth/checktoken/", data);
  }
  static getGroups() {
    return _get("users/groups/groups/");
  }
}
